// Constants

export const nomina_devengados = () => {
    return {
        nomina_devengados: {
            id: {
                namepath: ["afiliado_nomina"],
                description: 'id autoincrement',
                label: 'Id',
                name: 'solId',
                readonly: true,
                type: 'number',
                datatype: {
                    predeterminate: null
                }
            },
            id_info_nomina: {
                namepath: ["afiliado_nomina"],
                type: 'input',
                label: '',
                name: '',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    basico: true,
                    type: 'input',
                    disabled: false,
                    predeterminate: null,
                    label: ''
                },
            },
            concepto: {
                type: "text",
                label: "Gastos Menores",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            valor: {
                type: "number",
                label: "Valor",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: "$",
                }
            },
            predeterminado: {
                type: "number",
                label: "Valor",
                placeholder: "",
                namepath: ["afiliado_nomina"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: "",
                }
            },
        }
    }
}